// extracted by mini-css-extract-plugin
module.exports = {"gradientPill":"style-module__gradientPill___3GI6m","small":"style-module__small___cpmLs"};